// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_styles_loaderContainer__1ZLJ3","loader":"Loader_styles_loader__2SK9a","spin":"Loader_styles_spin__3iO1h"};